import React, { FunctionComponent } from 'react'
import styles from './ProgressBar.module.sass'
import clsx from 'clsx'
import { motion } from 'framer-motion'

interface Props {
    className?: string,
}

const ProgressBar: FunctionComponent<Props> = props => <motion.div
    className={clsx(props.className, styles.line)}
    initial={{ opacity: 0, height: 0 }}
    animate={{ opacity: 1, height: 6 }}
    exit={{ opacity: 0, height: 0 }}
>
    <div className={clsx(styles.progress, styles.inc)}/>
    <div className={clsx(styles.progress, styles.dec)}/>
</motion.div>

export default ProgressBar